import { xhr } from '@shared/config';

import { consultationApi } from '@src/entities/consultations';

export const useDeleteConsultation = (id: number) => {
	const onDelete = async () => {
		try {
			const res = await xhr.delete(`${consultationApi}${id}/`);
			console.log(res);
		} catch (error) {
			console.log(error);
		}
	};
	return {
		onDelete,
	};
};
